import * as types from './types';

const INITIAL_STATE = {};

function setPageData(state, action) {
    const {
        payload: {
            data,
            pageId,
        },
    } = action;

    return {
        ...state,
        [pageId]: data,
    };
}

const handlers = {
    [types.SET_PAGE_DATA]: setPageData,
};

function reducer(state = INITIAL_STATE, action) {
    if (handlers.hasOwnProperty(action.type)) {
        const handler = handlers[action.type];
        return handler(state, action);
    }

    return state;
}

export default reducer;
